import { createActions, createReducer } from 'reduxsauce'

import AditivosContratoService from '../../servicos/AditivosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaAditivosContratoInicio: [],
    buscaAditivosContratoSucesso: ['aditivosContrato'],
    buscaAditivosContratoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaAditivosContrato = filtro => {
    return dispatch => {
        dispatch(Creators.buscaAditivosContratoInicio())
        let serv = new AditivosContratoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaAditivosContratoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaAditivosContratoErro(error)))
    }
}

const buscaAditivosContratoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaAditivosContratoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaAditivosContratoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.aditivosContrato, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ADITIVOS_CONTRATO_INICIO]: buscaAditivosContratoInicio,
    [Types.BUSCA_ADITIVOS_CONTRATO_ERRO]: buscaAditivosContratoErro,
    [Types.BUSCA_ADITIVOS_CONTRATO_SUCESSO]: buscaAditivosContratoSucesso,
})
